import { render } from "./InventoryView.vue?vue&type=template&id=3e5a6556&scoped=true"
import script from "./InventoryView.vue?vue&type=script&lang=js"
export * from "./InventoryView.vue?vue&type=script&lang=js"

import "./InventoryView.vue?vue&type=style&index=0&id=3e5a6556&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5a6556"]])

export default __exports__